const initialState = {
  schoolRequests: [],
  collectiveRequests: [],
  activeSchools: [],
  activeCollective: [],
  changeAdminRequests: [],
  changeCollectiveAdminRequests: [],
  schoolStates: [],
  collegeStates: [],
  city: [],
  county: [],
  school: [],
  college: [],
  schoolSubAdmins: [],
  schoolEmails: [],
  lastSchoolRequestDocument: null,
  schoolRequestHasMore: true,
  lastApprovedSchoolDocument: null,
  hasMoreApprovedSchools: true,
  changeSchoolLastDocument: null,
  changeSchoolHasMore: true,
  // Collective request
  lastCollectiveRequestDocument: null,
  collectiveRequestHasMore: true,
  // Collective approved
  lastApprovedCollectiveDocument: null,
  hasMoreApprovedCollective: true,
  // Collective change request
  changeCollectiveLastDocument: null,
  changeCollectiveHasMore: true,
  // Un Registered Colleges
  unRegisteredColleges: {},
  unRegisteredSchools: {},
};

const schoolReducers = (state = initialState, action) => {
  switch (action.type) {
    case "GET_UN_REGISTERED_SCHOOLS":
      return {
        ...state,
        unRegisteredSchools: action.payload,
      };
    case "MORE_GET_UN_REGISTERED_SCHOOLS":
      return {
        ...state,
        unRegisteredSchools: {
          ...state.unRegisteredSchools,
          data: [...state.unRegisteredSchools.data, ...action.payload.data],
        },
      };
    case "GET_UN_REGISTERED_COLLEGES":
      return {
        ...state,
        unRegisteredColleges: action.payload,
      };
    case "MORE_GET_UN_REGISTERED_COLLEGES":
      return {
        ...state,
        unRegisteredColleges: {
          ...state.unRegisteredColleges,
          data: [...state.unRegisteredColleges.data, ...action.payload.data],
        },
      };

    case "UPDATE_SCHOOL_ADS_PERMISSION":
      let schools = state.activeSchools.map((items, index) =>
        items.id === action.payload.id
          ? {
              ...items,
              adImg: action.payload.data.adImg,
              permissionForAd: action.payload.data.permissionForAd,
            }
          : items
      );
      return {
        ...state,
        activeSchools: schools,
      };
    case "UPDATE_COLLECTIVE_ADS_PERMISSION":
      let collective = state.activeCollective.map((items, index) =>
        items.id === action.payload.id
          ? {
              ...items,
              adImg: action.payload.data.adImg,
              permissionForAd: action.payload.data.permissionForAd,
            }
          : items
      );
      return {
        ...state,
        activeCollective: collective,
      };
    case "SCHOOL_SUB_ADMINS":
      return {
        ...state,
        schoolSubAdmins: action.payload,
      };
    case "GET_SCHOOL_STATES":
      return {
        ...state,
        schoolStates: action.payload,
      };
    case "GET_COLLEGE_STATES":
      return {
        ...state,
        collegeStates: action.payload,
      };
    case "GET_CITY_BY_STATE":
      return {
        ...state,
        city: action.payload,
      };
    case "GET_COUNTY_BY_STATE":
      return {
        ...state,
        county: action.payload,
      };
    case "NEW_SCHOOLS":
      return {
        ...state,
        school: action.payload,
      };
    case "NEW_COLLEGE_UNIVERSITIES":
      return {
        ...state,
        college: action.payload,
      };
    case "GET_CHANGE_ADMIN_REQUEST":
      return {
        ...state,
        changeAdminRequests: action.payload.data,
        changeSchoolLastDocument: action.payload.lastDocument,
        changeSchoolHasMore: action.payload.hasMore,
      };
    case "MORE_GET_CHANGE_ADMIN_REQUEST":
      return {
        ...state,
        changeAdminRequests: [
          ...state.changeAdminRequests,
          ...action.payload.data,
        ],
        changeSchoolLastDocument: action.payload.lastDocument,
        changeSchoolHasMore: action.payload.hasMore,
      };
    case "GET_CHANGE_COLLECTIVE_ADMIN_REQUEST":
      return {
        ...state,
        changeCollectiveAdminRequests: action.payload.data,
        changeCollectiveLastDocument: action.payload.lastDocument,
        changeCollectiveHasMore: action.payload.hasMore,
      };
    case "GET_CHANGE_COLLECTIVE_ADMIN_REQUEST":
      return {
        ...state,
        changeCollectiveAdminRequests: [
          ...state.changeCollectiveAdminRequests,
          ...action.payload.data,
        ],
        changeCollectiveLastDocument: action.payload.lastDocument,
        changeCollectiveHasMore: action.payload.hasMore,
      };
    case "GET_APPROVED_SCHOOL":
      return {
        ...state,
        activeSchools: action.payload.data,
        schoolEmails: action.payload.schoolEmails,
        lastApprovedSchoolDocument: action.payload.lastDocument,
        hasMoreApprovedSchools: action.payload.hasMore,
      };
    case "MORE_GET_APPROVED_SCHOOL":
      return {
        ...state,
        activeSchools: [...state.activeSchools, ...action.payload.data],
        schoolEmails: [...state.schoolEmails, ...action.payload.schoolEmails],
        lastApprovedSchoolDocument: action.payload.lastDocument,
        hasMoreApprovedSchools: action.payload.hasMore,
      };
    case "GET_APPROVED_COLLECTIVE":
      return {
        ...state,
        activeCollective: action.payload.data,
        lastApprovedCollectiveDocument: action.payload.lastDocument,
        hasMoreApprovedCollective: action.payload.hasMore,
      };
    case "MORE_GET_APPROVED_COLLECTIVE":
      return {
        ...state,
        activeCollective: [...state.activeCollective, ...action.payload.data],
        lastApprovedCollectiveDocument: action.payload.lastDocument,
        hasMoreApprovedCollective: action.payload.hasMore,
      };
    case "GET_SCHOOL_REQUESTS":
      return {
        ...state,
        schoolRequests: action.payload.data,
        lastSchoolRequestDocument: action.payload.lastDocument,
        schoolRequestHasMore: action.payload.hasMore,
      };
    case "MORE_GET_SCHOOL_REQUESTS":
      return {
        ...state,
        schoolRequests: [...state.schoolRequests, ...action.payload.data],
        lastSchoolRequestDocument: action.payload.lastDocument,
        schoolRequestHasMore: action.payload.hasMore,
      };
    case "GET_COLLECTIVE_REQUESTS":
      return {
        ...state,
        collectiveRequests: action.payload.data,
        lastCollectiveRequestDocument: action.payload.lastDocument,
        collectiveRequestHasMore: action.payload.hasMore,
      };
    case "MORE_GET_COLLECTIVE_REQUESTS":
      return {
        ...state,
        collectiveRequests: [
          ...state.collectiveRequests,
          ...action.payload.data,
        ],
        lastCollectiveRequestDocument: action.payload.lastDocument,
        collectiveRequestHasMore: action.payload.hasMore,
      };
    // case "GET_APPROVED_SCHOOL":
    //   return {
    //     ...state,
    //     schoolRequests: action.payload.data,
    //   };
    case "REMOVE_SCHOOL":
      let uid = action.payload;
      let updatedRequests = state.schoolRequests.filter(
        (item) => item.id !== uid
      );
      return {
        ...state,
        schoolRequests: updatedRequests,
      };
    case "REMOVE_CHANGE_ADMIN_REQUEST":
      let updatedAdminRequests = state.changeAdminRequests.filter(
        (item) => item.id !== action.payload
      );
      return {
        ...state,
        changeAdminRequests: updatedAdminRequests,
      };
    default:
      return {
        ...state,
      };
  }
};

export default schoolReducers;
